module.exports = __webpack_public_path__ + "static/intertec_product_2-a1e8f309e30fc04779594ea453a3b2fc.png";